import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { useParams } from "react-router-dom";

function UniqueClientPage() {
  const { clientsApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(clientsApi);
  const [filteredData, setFilteredData] = useState({});
  let { id } = useParams();

  // filter by slug
  useEffect(() => {
    setFilteredData(
      apiData.filter((item) => !item.slug).filter((item) => item._id === id)[0]
        ?.clientsImg[0]
    );
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { name, image } = filteredData ?? {};

  //   // Form data
  const data = [
    {
      elementType: "file",
      label: "client image",
      type: "Text",
      name: "image",
      defaultValue: { url: image },
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "client name",
      type: "Text",
      name: "name",
      defaultValue: name,
      required: false,
    },
  ];

  const update = (data) => {
    const newData = { clientsImg: [data] };
    updateData(clientsApi, newData, id);
  };

  return <div>{name && <GlobalForm data={data} update={update} />}</div>;
}

export default UniqueClientPage;
